// @flow

import type { State } from "@store/reducers";
import type { EmailNotification } from "@modules/service/reducer/email-notifications/types";
import type { HierarchyAssignment } from "@modules/service/types";
import { validateHierarchyAssignmentSchema } from "./index";

export const getEmailNotificationsList = (state: State): Array<EmailNotification> =>
  state.service.emailNotifications.list.content;

export const getEmailNotificationSchema = (state: State): ?Object =>
  state.service.emailNotifications.schema;

export const getCurrentEmailNotification = (state: State): ?EmailNotification =>
  state.service.emailNotifications.current;

export const getEditedEmailNotification = (state: State): ?EmailNotification =>
  state.service.emailNotifications.edited;

export const getEmailNotificationAssignments = (state: State): Array<HierarchyAssignment> =>
  state.service.emailNotifications.assignments;

export const isEmailNotificationAssignmentsValid = (state: State): boolean => {
  const assignments = getEmailNotificationAssignments(state);
  return validateHierarchyAssignmentSchema(assignments);
};

export const getDefaultStepEmailNotificationModal = (state: State): number =>
  state.service.emailNotifications.modals.modalStep;

export const getShowAddEmailNotificationModal = (state: State): boolean =>
  state.service.emailNotifications.modals.showAddModal;

export const getShowEditEmailNotificationModal = (state: State): boolean =>
  state.service.emailNotifications.modals.showEditModal;

export const getShowDeleteEmailNotificationModal = (state: State): boolean =>
  state.service.emailNotifications.modals.showDeleteModal;
